import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Breadcrumb(props) {
    const { t, i18n } = useTranslation();
    return (
        // <section className="breadcrumb-area" style={{ backgroundAttachment:"fixed", backgroundImage: "url(" + process.env.PUBLIC_URL + "/assets/img/bg/"+props.breadcrumb.pagetitle.replace(" ","")+".jpg)" }}></section>
        <section className="breadcrumb-area" style={{ backgroundAttachment:"fixed", backgroundImage: "url(" + process.env.PUBLIC_URL + "/assets/img/bg/breadcrumb"+props.breadcrumb.bgImage+".jpg)" }}>
            <div className="container">
                <div className="breadcrumb-text">
                    <span>{i18n.t(props.breadcrumb.subtitlu)}</span>
                    <h2 className="page-title">{i18n.t(props.breadcrumb.pagename)}</h2>
                    <ul className="breadcrumb-nav">
                        <li><Link to="/">{i18n.t('meniu.home')}</Link></li>
                        <li className="active">{i18n.t(props.breadcrumb.pagename)}</li>
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default Breadcrumb;